import { z } from 'zod';
import { NestedProductQuoteResponseSchema } from '../product-quote/NestedQuoteResponseEntity.ts';
import { PROCESSING_TYPE_SCHEMA, PRODUCT_TYPE_SCHEMA } from '../product-type/product-types.ts';
import { NestedProductTypeResponseSchema } from '../product-type/NestedTypeResponseEntity.ts';
import { PRODUCT_CATEGORY_SCHEMA } from './product-category.ts';
import { NestedOrderProductConfigurationSchema } from './nested-product-configuration.ts';

export const PostOrderProductConfigurationRequestSchema = z.object({
    showZeroPurchasePrice: z.boolean(),
    showZeroSalesPrice: z.boolean(),
});

export const PostOrderProductRequestSchema = z.strictObject({
    // required
    index: z.number().positive(),
    type: PRODUCT_TYPE_SCHEMA,
    category: PRODUCT_CATEGORY_SCHEMA,
    templateId: z.optional(z.string().uuid()),
});

export const PostOrderProductResponseSchema = z.object({
    id: z.string(),
    orderProductGroupId: z.string(),
    positionProductId: z.string().uuid().nullable(),
    templateId: z.string().nullable(),
    index: z.number(),
    processingType: PROCESSING_TYPE_SCHEMA,
    type: PRODUCT_TYPE_SCHEMA,
    category: PRODUCT_CATEGORY_SCHEMA,
    productType: NestedProductTypeResponseSchema,
    orderProductConfiguration: NestedOrderProductConfigurationSchema,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    quote: NestedProductQuoteResponseSchema.nullable(),
});
